import { render, staticRenderFns } from "./StatementEmpty.vue?vue&type=template&id=0376f763&scoped=true"
import script from "./StatementEmpty.vue?vue&type=script&lang=ts"
export * from "./StatementEmpty.vue?vue&type=script&lang=ts"
import style0 from "./StatementEmpty.vue?vue&type=style&index=0&id=0376f763&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376f763",
  null
  
)

export default component.exports